import { OnInit } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
var StorageMovementCardComponent = /** @class */ (function () {
    function StorageMovementCardComponent() {
        this.isSameDayThanPrevious = false;
        this.createdByAvatarUrl = null;
        this.createdByName = null;
        this.storageMovementType = null;
    }
    StorageMovementCardComponent.prototype.ngOnInit = function () {
        var previousDate = this.previousDate && this.previousDate.split('T')[0];
        var currentDate = this.storageMovement.createdAt.split('T')[0];
        this.isSameDayThanPrevious = previousDate && (previousDate === currentDate);
        var avatarUrl = this.storageMovement.createdBy ? this.storageMovement.createdBy.avatarUrl : this.storageMovement.company.avatarUrl;
        this.createdByName = this.getName(this.storageMovement);
        this.createdByAvatarUrl = avatarUrl || 'http://ui-avatars.com/api/?name=' + this.createdByName;
        this.storageMovementType = this.mapStorageMovementType(this.storageMovement.type);
    };
    StorageMovementCardComponent.prototype.getName = function (storageMovement) {
        if (storageMovement.createdByName) {
            return storageMovement.createdByName;
        }
        if (storageMovement.createdBy) {
            return storageMovement.createdBy.name;
        }
        return storageMovement.company.name;
    };
    StorageMovementCardComponent.prototype.mapStorageMovementType = function (type) {
        switch (type) {
            case 'entry':
            case 'external_transfer_entry':
            case 'internal_transfer_entry':
                return 'entry';
            case 'removal':
            case 'external_transfer_removal':
            case 'internal_transfer_removal':
                return 'removal';
            default:
                return 'unknown';
        }
    };
    StorageMovementCardComponent.prototype.openStorageMovementDetails = function () {
        window.open(environment.MOUNTDOOM_2_URL + "/#/movimentacoes", '_blank');
    };
    return StorageMovementCardComponent;
}());
export { StorageMovementCardComponent };
